import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import { useSelector } from 'react-redux';

import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import LogIn from '../LogIn/index';
import LogInWorker from '../LogInWorker/index';
import Projects from '../Projects/index';
import Stickers from '../Stickers/index';
import ProjectCategory from '../ProjectCategory/index';
import StickerCategory from '../StickerCategory/index';
import Users from '../Users/index';
import Stats from '../Stats/index';
import Fonts from '../Fonts/index';
import StickersReview from '../StickersReview/index';
import AddSticker from '../AddSticker/index';
import Links from '../Links/index';
import LinkDetail from '../LinkDetail/index';
import PromoCode from '../PromoCode/index';

import { AuthProvider } from './authContext';

// const Pages = () => (
//   <Switch>
//     <Route path="/pages/one" component={ExamplePageOne} />
//     <Route path="/pages/two" component={ExamplePageTwo} />
//   </Switch>
// );

const privateRoutes = () => (
  <div>
    <Layout />
    {localStorage.getItem('type') == 0 ?
      <div className="container__wrap">
        <Route exact path="/" component={Projects} />
        <Route exact path="/projects" component={Projects} />
        <Route exact path="/stickers" component={Stickers} />
        <Route exact path="/stats" component={Stats} />
        <Route exact path="/project-category" component={ProjectCategory} />
        <Route exact path="/sticker-category" component={StickerCategory} />
        <Route exact path="/users" component={Users} />
        <Route exact path="/sticker-review" component={StickersReview} />
        <Route exact path="/links" component={Links} />
        <Route exact path="/link-detail/:id" component={LinkDetail} />
        <Route exact path="/fonts" component={Fonts} />
        <Route exact path="/promo-code" component={PromoCode} />
        <Redirect to="/" />
      </div> :
    <div className="container__wrap">
      <Route exact path="/" component={Users} />
      <Route exact path="/users" component={Users} />
      {/* <Route exact path="/add-sticker" component={AddSticker} /> */}
      <Redirect to="/" />
    </div> }
  </div>
);

const publicRouters = () => (
  <div>
    <Route exact path="/" component={LogIn} />
    <Route path="/login" component={LogIn} />
    {/* <Route path="/login-worker" component={LogInWorker} /> */}
  </div>
)

const Router = () => {
  const [authState, setAuthState] = useState(false);
  const spinner = useSelector(state => state.app.spinner);
  const text = useSelector(state => state.app.text);

  useEffect(() => {
    const auth = localStorage.getItem('auth');
    setAuthState(auth);
  }, []);

  const changeAuthState = () => {
    const auth = localStorage.getItem('auth');
    setAuthState(auth);
  }

  return (
    <MainWrapper>
      <AuthProvider value={changeAuthState}>
        <LoadingOverlay
          active={spinner}
          spinner
          text={text}
          >
          <main>
            <Switch>
              {
                !authState ?
                <Route path="/" component={publicRouters} /> :
                <Route path="/" component={privateRoutes} /> 
              }
            </Switch>
          </main>
        </LoadingOverlay>
      </AuthProvider>
      
    </MainWrapper>
  );
};

export default Router;
